import React, { MouseEventHandler } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DotLoader from 'react-spinners/DotLoader';
import cn from 'classnames';
interface ButtonProps {
	className?: string;
	handleClick?: Function | MouseEventHandler<HTMLButtonElement> | any;
	type?: 'submit' | 'a' | 'link' | 'div';
	loading?: boolean;
	to?: string;
	disabled?: boolean;
	background?: boolean;
	underline?: boolean;
	children?: React.ReactElement | React.ReactNode | any;
	textColor?: string;
	goBack?: boolean;
}

export const Button = ({
	className,
	handleClick,
	to,
	loading,
	type = 'div',
	disabled = false,
	background,
	underline = false,
	children,
	textColor = 'orange',
	goBack = false,
}: ButtonProps) => {
	const navigate = useNavigate();

	const child = !loading ? (
		children
	) : (
		<DotLoader
			color={background ? 'white' : '#ED5939'}
			size='20px'
			css={'display: block; position: relative; margin: 0 auto;'}
		/>
	);
	const classes = cn(
		{
			'bg-orange rounded-md px-4 py-3 text-white text-sm font-medium':
				background,
			'font-bold text-sm': !background,
			'hover:scale-105 duration-300': type === 'submit',
			'hover:no-underline underline underline-offset-2 font-light':
				underline && !background,
		},
		`text-${background ? 'white' : textColor}`,
		'text-center',
		className
	);

	const handleOnClick = () => {
		!disabled && handleClick && handleClick();
		!disabled && goBack && navigate(-1);
	};

	return type === 'submit' ? (
		<button
			disabled={disabled}
			type='submit'
			onClick={handleOnClick}
			className={classes}
		>
			{child}
		</button>
	) : type === 'a' ? (
		<a
			href={to}
			onClick={handleOnClick}
			className={classes}
		>
			{child}
		</a>
	) : type === 'link' && to ? (
		<Link
			to={to}
			onClick={handleOnClick}
			className={classes}
		>
			{child}
		</Link>
	) : (
		<div
			className={cn('cursor-pointer', classes)}
			onClick={handleOnClick}
		>
			{child}
		</div>
	);
};
